import React from 'react';
import Tasks from './TaskList.jsx';

const ContactTasksIndex = () => {
    return (
        <div>
            <Tasks context={"contact"} />
        </div>
    );
}

export default ContactTasksIndex;
